import {
  IsString,
  IsEnum,
  IsOptional,
  IsArray,
  IsUUID,
  IsDateString,
  MaxLength,
  MinLength,
} from 'class-validator'
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'
import {
  AnnouncementPriority,
  AnnouncementCategory,
  AnnouncementVisibility,
} from '../../../enums'

/**
 * DTO for creating a new announcement
 */
export class CreateAnnouncementDto {
  @ApiProperty({
    description: 'Announcement title',
    example: 'Exceptional closure',
    maxLength: 200,
  })
  @IsString()
  @MinLength(3)
  @MaxLength(200)
  title!: string

  @ApiProperty({
    description: 'Announcement content',
    example: 'The establishment will be closed on...',
  })
  @IsString()
  @MinLength(3)
  content!: string

  @ApiPropertyOptional({
    enum: AnnouncementPriority,
    default: AnnouncementPriority.NORMAL,
  })
  @IsEnum(AnnouncementPriority)
  @IsOptional()
  priority?: AnnouncementPriority = AnnouncementPriority.NORMAL

  @ApiPropertyOptional({ enum: AnnouncementCategory })
  @IsEnum(AnnouncementCategory)
  @IsOptional()
  category?: AnnouncementCategory

  @ApiPropertyOptional({
    enum: AnnouncementVisibility,
    default: AnnouncementVisibility.CUSTOM,
    description: 'Visibility level of the announcement',
  })
  @IsEnum(AnnouncementVisibility)
  @IsOptional()
  visibility?: AnnouncementVisibility = AnnouncementVisibility.CUSTOM

  @ApiPropertyOptional({ description: 'Target establishment ID' })
  @IsUUID()
  @IsOptional()
  establishmentId?: string

  @ApiPropertyOptional({ description: 'Target class ID' })
  @IsUUID()
  @IsOptional()
  classId?: string

  @ApiPropertyOptional({ description: 'Target subject ID' })
  @IsUUID()
  @IsOptional()
  subjectId?: string

  @ApiPropertyOptional({
    type: [String],
    description: 'Roles that can view the announcement',
    example: ['teacher', 'student', 'principal'],
  })
  @IsString({ each: true })
  @IsArray()
  @IsOptional()
  targetRoles?: string[]

  @ApiPropertyOptional({
    description: 'Specific user IDs to target',
    type: [String],
  })
  @IsUUID(undefined, { each: true })
  @IsArray()
  @IsOptional()
  targetUserIds?: string[]

  @ApiPropertyOptional({
    description: 'Publication date (null = draft)',
    example: '2024-01-15T10:00:00Z',
    type: 'string',
  })
  @IsDateString()
  @IsOptional()
  publishedAt?: string

  @ApiPropertyOptional({
    description: 'Expiration date',
    example: '2024-01-30T23:59:59Z',
    type: 'string',
  })
  @IsDateString()
  @IsOptional()
  expiresAt?: string

  @ApiPropertyOptional({
    description: 'Associated campaign ID (optional)',
    type: 'string',
  })
  @IsUUID()
  @IsOptional()
  campaignId?: string
}
